let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dg0Fz")).then(() => parcelRequire('jbr93'));